"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createActivitiesStyle;
function createActivitiesStyle() {
  return {
    margin: 0,
    padding: 0
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVBY3Rpdml0aWVzU3R5bGUiLCJtYXJnaW4iLCJwYWRkaW5nIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3R5bGVzL1N0eWxlU2V0L0FjdGl2aXRpZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlQWN0aXZpdGllc1N0eWxlKCkge1xuICByZXR1cm4ge1xuICAgIG1hcmdpbjogMCxcbiAgICBwYWRkaW5nOiAwXG4gIH07XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFlLFNBQVNBLHFCQUFxQkEsQ0FBQSxFQUFHO0VBQzlDLE9BQU87SUFDTEMsTUFBTSxFQUFFLENBQUM7SUFDVEMsT0FBTyxFQUFFO0VBQ1gsQ0FBQztBQUNIIn0=